export function parseMainNumbers(result: string | null | undefined): number[] {
  if (!result) return [];
  try {
    const arr = JSON.parse(result);
    return Array.isArray(arr[0]) ? arr[0] : [];
  } catch {
    return [];
  }
}

export function parseBonusNumbers(result: string | null | undefined): number[] {
  if (!result) return [];
  try {
    const arr = JSON.parse(result);
    return Array.isArray(arr[1]) ? arr[1] : [];
  } catch {
    return [];
  }
}

/** Active account theme overrides (from theme JSON, e.g. wsb). */
let themeGameFlagsBySlug: Record<string, string> = {};
let themeGameFlagsBySlugPrefix: Record<string, string> = {};

export function setThemeGameFlags(
  bySlug?: Record<string, string>,
  bySlugPrefix?: Record<string, string>
): void {
  themeGameFlagsBySlug = bySlug ?? {};
  themeGameFlagsBySlugPrefix = bySlugPrefix ?? {};
}

function resolveSlugFlag(gameSlug: string): string | undefined {
  const slug = gameSlug.toLowerCase();

  if (slug in themeGameFlagsBySlug) {
    return themeGameFlagsBySlug[slug];
  }

  for (const [prefix, flagFile] of Object.entries(themeGameFlagsBySlugPrefix)) {
    if (slug.startsWith(prefix.toLowerCase())) {
      return flagFile;
    }
  }

  return undefined;
}

export function hasGameFlag(
  gameLogo: string | null | undefined,
  gameSlug?: string | null | undefined
): boolean {
  if (gameSlug && resolveSlugFlag(gameSlug)) {
    return true;
  }
  return Boolean(gameLogo);
}

export function getGameLogoUrl(
  gameLogo: string | null | undefined,
  gameSlug?: string | null | undefined
): string {
  const slugFlag = gameSlug ? resolveSlugFlag(gameSlug) : undefined;
  if (slugFlag) {
    return `/img/flags/${slugFlag}`;
  }
  return `/img/flags/${gameLogo}`;
}

export function formatDrawTime(dateStr: string): string {
  if (!dateStr) return '';
  const date = new Date(dateStr.replace(' ', 'T'));
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${day}/${month}/${year}, ${hours}:${minutes}`;
}
